import React from 'react';
import classNames from 'classnames'
import { MenuOutlined } from '@ant-design/icons'
import {Button, Space } from 'antd';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import './header.scss';
import CategorySelect from './navigation-bar/category-menu/category';

export interface HeaderProps {
  logoSrc?: string;
  logoSize?: 'small' | 'middle' | 'large';
  logoHref?: string;
  isFixed?: boolean;
  hasSidebar?: boolean;
  onTogglerClick?: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  logoSrc,
  logoSize='middle',
  logoHref,
  isFixed='true',
  hasSidebar='true',
  children,
  onTogglerClick,
}) => {
  return (
    <div className="header">
      <div className={classNames('header--inner', { 'fixed': isFixed })}>
        {hasSidebar &&
          <div className="toggler" onClick={onTogglerClick}>
            <MenuOutlined />
          </div>
        }

        {logoSrc &&
          <div
            className={classNames('logo', {
              'logo--sm': logoSize === 'small',
              'logo--lg': logoSize === 'large',
            })}
          >
            <Link to={logoHref || ''}><img src={logoSrc} /></Link>
          </div>
        }
        {/*<CategorySelect />*/}
        <div className="header--body">
          {children}
        </div>

      </div>
    </div>
  )
}
